/** Credentials' part of "Download my data": the caller's files here. */
export const myDataApi = '/credentials/v1/me/data'
